import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { defaultTo, compose, path } from 'ramda';
import { withFormik } from 'formik';
import Select from 'react-select';

import { apiUpdateExamResult, apiDeleteExamResult } from '../../api/registration';
import { handleError, handleSuccess, handleSuccessBase, handleErrorBase } from '../../util/forms';
import { isNilOrEmpty } from '../../util/redux';
import registrationActions from '../../redux/registration';

import Modal from '../Modal';
import EditField from '../Forms/EditField';
import Checkbox from '../Forms/Checkbox';

const mapDispatch = {
  ...registrationActions,
};

class ExamResultModal extends Component {
  static propTypes = {
    exam: PropTypes.object,
    onHide: PropTypes.func,
    registration: PropTypes.object.isRequired,
    updateRegistrationExams: PropTypes.func,
  };

  state = {
    show: false,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState && !prevState.show && nextProps.show && nextProps.resetForm) {
      nextProps.resetForm();
    }

    return { show: defaultTo(false, nextProps.show) };
  }

  render() {
    const {
      onHide,
      values,
      handleBlur,
      handleChange,
      handleSubmit,
      setFieldValue,
      isSubmitting,
      isValid,
      status,
      registration,
      exam,
      updateRegistrationExams,
    } = this.props;
    const { show } = this.state;
    const oldScore = path(['extra', 'score'], exam);

    return (
      <Modal show={show} onHide={onHide} title="Edit Exam Result">
        <form>
          <Modal.Body className="px-5">
            <EditField
              full
              name="score"
              label="Score"
              type="number"
              status={status}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.score}
            />
            <EditField
              full
              as={Select}
              bare
              simpleValue
              label="Result"
              name="result"
              status={status}
              onChange={(value) => setFieldValue('result', value)}
              onBlur={handleBlur}
              value={values.result}
              options={[
                { value: 'P', label: 'Pass' },
                { value: 'F', label: 'Fail' },
                { value: 'A', label: 'Absent' },
              ]}
            />
            <EditField
              full
              name="takenAt"
              label="Taken On"
              type="date"
              status={status}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.takenAt}
            />
            <EditField
              full
              name="paidOn"
              label="Paid On"
              type="date"
              status={status}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.paidOn}
            />
            <Checkbox name="retake" label="Is an exam retake" checked={values.retake} onChange={handleChange} />
            {isNilOrEmpty(oldScore) && !isNilOrEmpty(values.score) && (
              <EditField
                block
                name="message"
                label="Message to include in the notification email (optional)"
                status={status}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.message}
              />
            )}
          </Modal.Body>
          <Modal.Footer>
            {exam.id && (
              <button
                type="button"
                className="btn btn-danger mr-auto"
                onClick={() =>
                  apiDeleteExamResult(registration.id, exam.id)
                    .then(({ data }) => updateRegistrationExams(data))
                    .then(() => handleSuccessBase())
                    .then(onHide)
                    .catch((err) => handleErrorBase())
                }
              >
                Delete
              </button>
            )}
            <button type="button" className="btn btn-secondary" onClick={onHide}>
              Close
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={!isValid || isSubmitting}
              onClick={handleSubmit}
            >
              Save changes
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

export default compose(
  connect(null, mapDispatch),
  withFormik({
    handleSubmit: (payload, formProps) => {
      const { props } = formProps;

      apiUpdateExamResult(props.registration.id, payload)
        .then(({ data }) => props.updateRegistrationExams(data))
        .then(() => handleSuccess(formProps))
        .then(props.onHide)
        .catch((err) => handleError(formProps, err));
    },
    mapPropsToValues: ({ exam = {} }) => {
      const paidOn = defaultTo('', path(['transaction', 'createdAt'], exam));
      return {
        id: exam.id,
        score: defaultTo('', path(['extra', 'score'], exam)),
        result: defaultTo('', path(['extra', 'result'], exam)),
        takenAt: defaultTo('', path(['extra', 'takenAt'], exam)),
        paidOn: paidOn.substr(0, paidOn.indexOf(' ')),
        retake: defaultTo(false, path(['extra', 'retake'], exam)),
        message: '',
      };
    },
    isInitialValid: true,
    validateOnChange: true,
  }),
)(ExamResultModal);
